// extracted by mini-css-extract-plugin
module.exports = {"TabContent":"SignUpTabs_TabContent__S0eGe"};